import React from 'react'

import './Spinner.scss'
import classNames from 'classnames'

export function Spinner(props: { center?: boolean, size?: number, inline?: boolean, margin?: string }) {
  return (
    <div
      className={classNames('Spinner', { centerAbsolute: props.center, inline: props.inline })}
      style={
        typeof props.size === 'number' ? {
          width: `${props.size}px`,
          height: `${props.size}px`,
          margin: props.margin,
        } : undefined
      }
    />
  )
}
